export const HIGHLIGHT_COLOR = Styles.color.primary;

export const incentiveCardImageDefaultProps = {
  objectFitContain: true,
};
